import { Space, Button } from "antd";
import { useQuizContext } from "Pages/MySchedule/MyScheduledBeta/quiz/context/QuizContext";

const QuizBuilderFooter = () => {
  const { onFinish, selectedQuestions, editableQuiz } = useQuizContext();
  const finishHandler = (values: any) => {
    console.log(values);
  };
  const isDisabled = !selectedQuestions.length;
  return (
    <Space
      style={{
        justifyContent: "flex-end",
        position: "fixed",
        bottom: 10,
        right: 20,
      }}
    >
      <Button
        disabled={isDisabled}
        type="primary"
        onClick={() => {
          if (editableQuiz.id) {
            onFinish(finishHandler, editableQuiz.id);
          } else {
            onFinish(finishHandler);
          }
        }}
        className="ml-3"
      >
        {editableQuiz.id ? "Update Quiz" : "Create Quiz"}
      </Button>
    </Space>
  );
};

export default QuizBuilderFooter;
